"use client";

import { useState } from "react";
import { cn } from "@/utils";

export type FaqItem = { question: string; answer: string };

/** Accordion list — design `.faq-item`. */
const Faq = ({ items, className }: { items: FaqItem[]; className?: string }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className={cn("jlt-mx-auto jlt-max-w-[760px]", className)}>
      {items.map((item, i) => {
        const open = openIndex === i;

        return (
          <div
            key={item.question}
            className={cn(
              "jlt-mb-3 jlt-overflow-hidden jlt-rounded-[18px] jlt-border jlt-border-pl-line jlt-bg-white jlt-transition-shadow jlt-duration-300",
              open && "jlt-shadow-pl-sm"
            )}
          >
            <button
              type="button"
              aria-expanded={open}
              onClick={() => setOpenIndex(open ? null : i)}
              className="jlt-flex jlt-w-full jlt-items-center jlt-justify-between jlt-gap-[14px] jlt-px-[22px] jlt-py-[18px] jlt-text-left jlt-font-display jlt-text-[16px] jlt-font-bold jlt-text-pl-ink"
            >
              {item.question}
              <span
                className={cn(
                  "jlt-grid jlt-h-[30px] jlt-w-[30px] jlt-flex-none jlt-place-items-center jlt-rounded-full jlt-bg-pl-blue-soft jlt-text-[16px] jlt-text-pl-blue jlt-transition-transform jlt-duration-300 jlt-ease-spring",
                  open && "jlt-rotate-45"
                )}
              >
                +
              </span>
            </button>

            <div
              className={cn(
                "jlt-grid jlt-px-[22px] jlt-text-[14.5px] jlt-leading-[1.62] jlt-text-pl-ink2 jlt-transition-[grid-template-rows,padding] jlt-duration-300 jlt-ease-spring",
                open ? "jlt-grid-rows-[1fr] jlt-pb-[18px]" : "jlt-grid-rows-[0fr]"
              )}
            >
              <div className="jlt-overflow-hidden">{item.answer}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Faq;
